import { ReactElement } from 'react'
import i18n from 'lang/i18n'
import HorizontalRule from 'ui/atoms/HorizontalRule'
import { Header, List, OfferWrapper, SubHeader } from './subcomponents'

/** Returns translation from clientOffering field of i18n module */
const t = (key: string) => i18n({ clientOffering: key })

const DefaultOfferInfo = (): ReactElement => {
  return (
    <OfferWrapper>
      <Header weight="regular">{t('Log in to get started')}</Header>
      <HorizontalRule isTitleBorder topSpacing="20px" bottomSpacing="16px" />
      <SubHeader weight="regular">{t('Manage your Account online')}</SubHeader>
      <List>
        <li>{t('Account overview')}</li>
        <li>{t('Electronic Statements')}</li>
        <li>{t('Payments')}</li>
        <li>{t('Download transaction details')}</li>
        <li>{t('View your Account History and more')}</li>
      </List>
    </OfferWrapper>
  )
}

export default DefaultOfferInfo
